import { useTranslation } from 'react-i18next';
import type { AlertItem as AlertItemType, AlertKind } from '@interfaces/IAlertItem';
import { MockPill } from '@components/ui/MockPill/MockPill';
import { ZapIcon } from '@utils/icons';
import { AlertItem } from './AlertItem/AlertItem';
import styles from './styles.module.css';

type IAlertsRailProps = { alerts: AlertItemType[] };

const headingId = 'portfolio-alerts-heading';
const MOCKED_KINDS: ReadonlySet<AlertKind> = new Set(['blocker', 'delivery', 'stock']);

export function AlertsRail({ alerts }: IAlertsRailProps) {
  const { t } = useTranslation();
  const hasMockedAlerts = alerts.some((a) => MOCKED_KINDS.has(a.kind));
  return (
    <aside className={styles.rail} aria-labelledby={headingId}>
      <div className={styles.titleRow}>
        <span className={styles.titleIcon} aria-hidden>
          <ZapIcon size={16} />
        </span>
        <h2 id={headingId} className={styles.title}>{t('portfolio.alerts.title')}</h2>
        {hasMockedAlerts && <MockPill kind="badge" />}
      </div>
      <div className={styles.list}>
        {alerts.map((a, i) => (
          <AlertItem key={`${a.site}-${i}`} alert={a} />
        ))}
      </div>
    </aside>
  );
}
